import React from "react"
import Swiper from "react-id-swiper"
import styled from "@emotion/styled"

import "./productTypeBlock.scss"

const StyledSwiper = styled(Swiper)`
  background: black;
  justify-content: center;

  .swiper-button-next {
    right: 100%;
  }
`

const StyledImage = styled.div`
  ${props =>
    props.imageHeight !== "" && props.imageHeight
      ? ` height: ${props.imageHeight}px; `
      : `height: 120px; `}
  width: auto;
`

const ProductTypeBlock = props => {
  const params = {
    slidesPerView: 4,
    watchOverflow: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    centerInsufficientSlides: true,
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      991: {
        slidesPerView: 2,
      },
      540: {
        slidesPerView: 1,
      },
    },
    autoplay: false,
  }

  return (
    <div className="product-type-block">
      <div className="container">
        <h2 className="headline">{props.headline}</h2>
        <div
          className="product-type-block__body-copy"
          dangerouslySetInnerHTML={{ __html: props.body_copy }}
        />
        <StyledSwiper {...params}>
          {props.game_types.map((type, index) => (
            <div key={index}>
              <div className="product-type-block__slide">
                <StyledImage
                  className="product-type-block__image"
                  imageHeight={props.game_types_badge_height}
                >
                  <img src={type.badge.url} alt="product badge" />
                </StyledImage>
                <div className="product-type-block__overlay">
                  <div className="product-type-block__text-container">
                    <div className="product-type-block__text">
                      <p className="product-type-block__text-header">
                        {type.headline}
                      </p>
                      <p className="product-type-block__text-copy">
                        {type.body_copy}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </StyledSwiper>
      </div>
    </div>
  )
}

export default ProductTypeBlock
